/**
 * A prompt composer marks its textarea with a `data-composer` attribute naming
 * which composer it is. Shortcuts that should still work while someone writes
 * a prompt look for that attribute.
 */
export function isPromptComposer(target: EventTarget | null): target is HTMLTextAreaElement {
  return target instanceof HTMLTextAreaElement && target.dataset.composer !== undefined;
}

/** Hotkey options that let a shortcut fire from a prompt composer but no other text field. */
export const COMPOSER_HOTKEY_OPTIONS = {
  enableOnFormTags: ['textarea'],
  ignoreEventWhen: (event: KeyboardEvent) =>
    event.target instanceof HTMLTextAreaElement && !isPromptComposer(event.target),
} as const;
